import React, { useEffect, useRef, useState } from 'react'
import BlankCoverImage from '../../assets/blank_cover.png'
import { UploadIcon } from '@heroicons/react/outline'
import { useRecoilState } from 'recoil'
import { contentInput } from '../../recoil/content'

const CoverInput = () => {
  const hiddenFileInput = useRef(null);
  const [input, setInput] = useRecoilState(contentInput);
  const [preview, setPreview] = useState();

  const changeCover = (cover) => {
    let newInput = {...input};
    newInput.cover = cover;
    setInput(newInput);
  };

  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  useEffect(() => {
    if (!input.cover) {
      setPreview(undefined);
      return
    }
    const objectUrl = URL.createObjectURL(input.cover);
    setPreview(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [input.cover]);

  return (
    <div className="flex flex-col items-center w-1/4 gap-5">
        <img src={input.cover ? preview : BlankCoverImage} alt="Cover" className="w-full rounded-lg" />
        <input type="file" onChange={e => changeCover(e.target.files[0])} ref={hiddenFileInput} className="hidden" />
        <button onClick={handleClick} type="button" className="flex items-center justify-center gap-3 px-5 py-3 rounded-lg shadow bg-slate-50 hover:bg-slate-100 shadow-blue-100">
            <UploadIcon className="w-5 h-5"/>
            <span>Upload Cover</span>
        </button>
    </div>
  )
}

export default CoverInput